import { FC, useMemo } from "react";

type SpacerProps = {
  width: string;
  height: string;
}
export const Spacer: FC<SpacerProps> = ({
  width,
  height
}) => {
  const style = useMemo(() => {
    return {
      width,
      height,
      flex: `0 0 ${width}`
    }
  }, [width, height])

  return <div style={style}></div>
}